import { render, staticRenderFns } from "./MandatsNews.vue?vue&type=template&id=57774a6c&"
import script from "./MandatsNews.vue?vue&type=script&lang=js&"
export * from "./MandatsNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports